export default __webpack_public_path__ + "036f5fb12152d2ea345ab3720c64edf0.png";